<script setup lang="ts">
import type { BinaryBodyContent, BinaryReference } from '@/types'
import BinaryReferencePicker from '../BinaryReferencePicker.vue'

// The HTTP binary body is always a reference to upstream bytes (ADR-034) — streamed by the engine,
// never evaluated. There is no expression alternative here, so no mode toggle.
const props = defineProps<{
  modelValue: BinaryBodyContent
}>()

const emit = defineEmits<{
  'update:modelValue': [value: BinaryBodyContent]
}>()

function update(source: BinaryReference) {
  emit('update:modelValue', { $type: 'binary', source })
}
</script>

<template>
  <div class="mb-3">
    <label class="form-label">Binary Body</label>
    <BinaryReferencePicker :model-value="modelValue.source" @update:model-value="update" />
    <div class="form-text">
      Sends the referenced upstream data as the request body, streamed as raw bytes (no size limit).
    </div>
  </div>
</template>
